<span [innerHTML]="fullTagName | tagHighlightSearch:(qsWord|async):bgColor:fgColor | safeHtml"></span>
